import script from "./AdminManageUser.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminManageUser.vue?vue&type=script&setup=true&lang=js"

import "./AdminManageUser.vue?vue&type=style&index=0&id=e875fc36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e875fc36"]])

export default __exports__